module.exports = __webpack_public_path__ + "img/charging-station-light.8fc60e35.svg";